'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Modal = require('./Modal.scss');

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalConstants = require('./ModalConstants');

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _CloseThin = require('./../Icons/dist/components/CloseThin');

var _CloseThin2 = _interopRequireDefault(_CloseThin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHILDREN_WRAPPER_DIV_ID = 'modal-children-container';

var Modal = function (_WixComponent) {
  _inherits(Modal, _WixComponent);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.handleOverlayClick = function (event) {
      var _this$props = _this.props,
          shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
          onRequestClose = _this$props.onRequestClose;

      if (shouldCloseOnOverlayClick && event.target.id === CHILDREN_WRAPPER_DIV_ID) {
        onRequestClose();
      }
    }, _this.renderCloseButton = function () {
      return _react2.default.createElement(
        'div',
        {
          onClick: _this.props.onRequestClose,
          className: _Modal2.default.closeButton,
          'data-hook': 'modal-close-button'
        },
        _react2.default.createElement(_CloseThin2.default, { size: '18px' })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          horizontalPosition = _props.horizontalPosition,
          verticalPosition = _props.verticalPosition,
          height = _props.height,
          scrollableContent = _props.scrollableContent,
          borderRadius = _props.borderRadius,
          zIndex = _props.zIndex,
          scrollable = _props.scrollable,
          theme = _props.theme,
          isOpen = _props.isOpen,
          shouldCloseOnOverlayClick = _props.shouldCloseOnOverlayClick,
          shouldDisplayCloseButton = _props.shouldDisplayCloseButton,
          onRequestClose = _props.onRequestClose,
          onAfterOpen = _props.onAfterOpen,
          contentLabel = _props.contentLabel,
          closeTimeoutMS = _props.closeTimeoutMS,
          children = _props.children,
          appElement = _props.appElement,
          overlayPosition = _props.overlayPosition,
          parentSelector = _props.parentSelector;
      var maxHeight = this.props.maxHeight;

      var justifyContent = _ModalConstants.flexPositions[horizontalPosition];
      var alignItems = _ModalConstants.flexPositions[verticalPosition];

      maxHeight = scrollableContent && maxHeight === 'auto' ? '100vh' : maxHeight;

      var modalStyles = {
        overlay: {
          // Overriding defaults
          position: overlayPosition,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 11 + (zIndex || 0),
          backgroundColor: null, // null disables the property, use css instead
          // Overriding defaults - END
          display: 'flex',
          justifyContent: justifyContent,
          alignItems: alignItems,
          overflowY: scrollable ? 'auto' : 'hidden'
        },
        content: {
          // Overriding defaults
          border: 'none',
          overflowY: scrollableContent ? 'auto' : 'initial',
          overflowX: scrollableContent ? 'hidden' : 'initial',
          height: height,
          maxHeight: maxHeight,
          width: '100%',
          WebkitOverflowScrolling: 'touch',
          outline: 'none',
          borderRadius: borderRadius,
          padding: '0px',
          // Overriding defaults - END
          backgroundColor: 'transparent',
          marginBottom: '0px',
          position: 'relative'
        }
      };

      var modalClasses = _Modal2.default.modal + ' ' + _Modal2.default[theme];
      var portalClassName = (0, _classnames3.default)(_Modal2.default.portal, _defineProperty({}, _Modal2.default.portalNonScrollable, !scrollable));

      if (appElement) {
        _reactModal2.default.setAppElement(appElement);
      } else {
        _reactModal2.default.setAppElement('body');
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactModal2.default,
          {
            portalClassName: portalClassName,
            isOpen: isOpen,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
            onRequestClose: onRequestClose,
            onAfterOpen: onAfterOpen,
            style: modalStyles,
            className: modalClasses,
            contentLabel: contentLabel,
            closeTimeoutMS: closeTimeoutMS,
            parentSelector: parentSelector
          },
          isOpen && shouldDisplayCloseButton && this.renderCloseButton(),
          _react2.default.createElement(
            'div',
            {
              id: CHILDREN_WRAPPER_DIV_ID,
              className: _Modal2.default.childrenContainer,
              onClick: this.handleOverlayClick
            },
            children
          )
        )
      );
    }
  }]);

  return Modal;
}(_WixComponent3.default);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  contentLabel: _propTypes2.default.string.isRequired,
  theme: _propTypes2.default.oneOf(Object.keys(_ModalConstants.colors)),
  children: _propTypes2.default.any,
  zIndex: _propTypes2.default.number,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldDisplayCloseButton: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  onAfterOpen: _propTypes2.default.func,
  horizontalPosition: _propTypes2.default.oneOf(Object.keys(_ModalConstants.flexPositions)),
  verticalPosition: _propTypes2.default.oneOf(Object.keys(_ModalConstants.flexPositions)),
  closeTimeoutMS: _propTypes2.default.number,
  scrollable: _propTypes2.default.bool,
  scrollableContent: _propTypes2.default.bool,
  maxHeight: _propTypes2.default.string,
  height: _propTypes2.default.string,
  overlayPosition: _propTypes2.default.oneOf(Object.keys(_ModalConstants.positions)),
  parentSelector: _propTypes2.default.func
};
Modal.defaultProps = {
  onOk: function onOk() {},
  borderRadius: 0,
  theme: _ModalConstants.colors.blue,
  shouldCloseOnOverlayClick: false,
  shouldDisplayCloseButton: false,
  horizontalPosition: 'center',
  verticalPosition: 'center',
  closeTimeoutMS: 500,
  scrollable: true,
  scrollableContent: false,
  height: '100%',
  maxHeight: 'auto',
  overlayPosition: 'fixed'
};
exports.default = Modal;